// Keep the cycle's reference intact. A unique owner's bike is only a display
// fallback for inconsistent legacy cycles, explicitly marked for review.
export default function resolveParkingBike(cycle, bikesMap) {
  const referenced = bikesMap.get(String(cycle.id_byke));
  if (referenced && String(referenced.id_user) === String(cycle.id_user)) {
    return { bike: referenced, bikeAssociationNeedsReview: false };
  }
  const owned = [...bikesMap.values()].filter(
    (bike) => String(bike.id_user) === String(cycle.id_user)
  );
  return { bike: owned.length === 1 ? owned[0] : null, bikeAssociationNeedsReview: true };
}
